// components/notifications/ToastNotification.jsx
import React, { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';

const ToastNotification = ({ notification, onClose, onClick }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    
    return () => clearTimeout(timer);
  }, [onClose]);
  
  const getIcon = (type) => {
    switch (type) {
      case 'order': return '🛒';
      case 'message': return '💬';
      case 'rating': return '⭐';
      case 'boost': return '⚡';
      case 'favorite': return '❤️';
      case 'dispute': return '⚠️';
      case 'payment': return '💰';
      default: return '🔔';
    }
  };
  
  return (
    <div 
      className="fixed top-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-white rounded-xl shadow-xl border-l-4 border-orange-500 p-4 z-50 animate-slide-down cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-start gap-3">
        <div className="text-2xl">
          {getIcon(notification.type)}
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-gray-900 text-sm">
            {notification.title}
          </h4>
          <p className="text-gray-600 text-sm mt-1">
            {notification.message}
          </p>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          className="text-gray-400 hover:text-gray-600"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

// Toast container component
export const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);
  
  useEffect(() => {
    const handleShowToast = (event) => {
      const id = Date.now();
      setToasts(prev => [...prev, { id, ...event.detail }]);
      
      // Auto remove after 5 seconds
      setTimeout(() => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
      }, 5000);
    };
    
    window.addEventListener('showToast', handleShowToast);
    
    return () => {
      window.removeEventListener('showToast', handleShowToast);
    };
  }, []);
  
  return (
    <div className="fixed top-4 left-0 right-0 z-50 flex flex-col items-center gap-2 pointer-events-none">
      {toasts.map(toast => (
        <div key={toast.id} className="pointer-events-auto w-full max-w-md mx-4">
          <ToastNotification
            notification={toast}
            onClose={() => setToasts(prev => prev.filter(t => t.id !== toast.id))}
            onClick={() => {
              if (toast.onClick) toast.onClick();
              setToasts(prev => prev.filter(t => t.id !== toast.id));
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;